import { createClient } from '@supabase/supabase-js';
import React, { useEffect, useState, createContext } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } from './constants';
import "./App.css"
import { Lava } from './lava';
import { Vasta } from './vasta';
import { Pult } from './pult';
import { Kava } from './kava';
import QRCodeGrid from './qrs';

export const supabase = createClient(
  REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_KEY, 
  {db:{schema:'salme'}});

export const UserContext = createContext(); 
export const CurrentContext = createContext(); 

const App = () => {
  const [session,setSession] = useState(null);
  const [play, setPlay] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const page = location?.pathname?.split("/")?.[1];
    document.title = `Andmeteater ${page ? `- ${page}` : ""}`;
  }, [location]);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)})
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)});
  }, [location]);

  const fetchPlay = async () => {
    const { data, error } = await supabase.from("events").select("*").eq("play", true).single();
    if (error) {
      console.error("Error fetching user:", error);
    } else {
      setPlay(data.id);
    }
  };

  useEffect(() => {
    fetchPlay();
  }, []);

  

  return <>
    <CurrentContext.Provider value={play}>
    <UserContext.Provider value={session}>
      <main id="main">
        <Routes>
            <Route path="/" element={<Kava/>} />
            <Route path="/lava" element={<Lava />}>
              <Route path=":id" element={<Lava />}/>
            </Route>
            <Route path="/pult" element={<Pult />}>
              <Route path=":id" element={<Pult />}/>
            </Route>
            <Route path="/vasta" element={<Vasta />}>
              <Route path=":id" element={<Vasta />}/>
            </Route>
            <Route path="/teeskle" element={<Vasta mock={true}/>}>
              <Route path=":id" element={<Vasta mock={true} />}/>
            </Route>
            <Route path="/qr" element={<QRCodeGrid/>}>
              <Route path=":id" element={<QRCodeGrid />}/>
            </Route>
          </Routes>
      </main>
    </UserContext.Provider>
    </CurrentContext.Provider>
  </>;
};

export default App;
